export function convertDate(date: string) {
  return date ? new Date(date) : null;
}

export function convertDateUTC(date: string) {
  return date ? new Date(date + '.00Z') : null;
}

export function dateFormat(date: Date) {
  return date ? date.toLocaleString() : null;
}
export function daysAgo(date: Date): number | null {
  if (!date) return null;
  const now = new Date();
  const diffTime = now.getTime() - date.getTime();
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}

export function timeAgo(date: Date): string | null {
  if (!date) return null;
  const now = new Date();
  const diffTime = now.getTime() - date.getTime();

  const minutes = Math.floor(diffTime / (1000 * 60));
  if (minutes < 1) return 'Just now';
  if (minutes === 1) return '1 minute ago';
  if (minutes < 60) return `${minutes} minutes ago`;

  const hours = Math.floor(diffTime / (1000 * 60 * 60));
  if (hours === 1) return '1 hour ago';
  if (hours < 24) return `${hours} hours ago`;

  const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  if (days === 1) return '1 day ago';
  if (days < 30) return `${days} days ago`;

  const months = Math.floor(days / 30);
  if (months === 1) return '1 month ago';
  return `${months} months ago`;
}
